<template>
	<div>
		<v-data-table :headers="headers" :items="installments" :items-per-page="500" class="elevation-1 mb-3">
			<template v-slot:item="row">
				<tr>
					<td>{{ row.item.memberPersonalCode }}</td>
					<td>{{ row.item.memberFullName }}</td>
					<td>{{ `${row.item.targetMonth_Persian.year}/${row.item.targetMonth_Persian.month}` }}</td>
					<td>{{ row.item.loanTitle }}</td>
					<td class="text-center">
						{{ row.item.total.toString().toPriceFormat() }} تومان
					</td>
					<td class="text-center">
						{{ row.item.installment.toString().toPriceFormat() }} تومان
					</td>
					<td class="text-center">
						{{ row.item.remain.toString().toPriceFormat() }} تومان
					</td>
				</tr>
			</template>
		</v-data-table>

		<div v-if="loading" class="loading flex-start ">
			<v-progress-circular :size="50" color="white" indeterminate />
			<div class="white--text mt-2">
				در حال بارگذاری...
			</div>
		</div>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'InstallmentsByMonthView',
		components: {
		},
		props: {
			date: { type: String },
		},
		data() {
			return {
				errorMessages: '',
				installments: [],
				headers: [{
					text: 'کد پرسنلی',
					align: 'center',
					sortable: true,
					value: 'memberPersonalCode',
				}, {
					text: 'نام عضو',
					align: 'center',
					sortable: true,
					value: 'memberFullName',
				}, {
					text: 'ماه',
					align: 'center',
					sortable: true,
					value: 'targetMonth_Persian',
				}, {
					text: 'نوع وام',
					align: 'right',
					sortable: true,
					value: 'loanTitle',
				}, {
					text: 'مبلغ وام',
					align: 'center',
					sortable: true,
					value: 'total',
				}, {
					text: 'مبلغ قسط',
					align: 'center',
					sortable: true,
					value: 'installment',
				}, {
					text: 'باقیمانده',
					align: 'center',
					sortable: true,
					value: 'remain',
				},
				],
				loading: false,
			}
		},
		mounted() {
		},
		methods: {
			loadData() {
				if (!this.date || this.date === '') { return }
				this.loading = true
				api.get('admin/LoanPayment/getListByTargetMonth/' + this.date.replaceAll('/', '-'), null)
					.then(
						response => {
							this.installments = response
						})
					.catch(err => {
						toast.error(err.message)
					}).finally(x => { this.loading = false })
			},
		},
	}
</script>
<style>
</style>
